/**
 * Format amount in lakhs with appropriate decimal precision
 * @param {number} amount - The amount to format
 * @returns {string} Formatted amount string
 */
export const formatAmount = (amount) => {
  const lakhAmount = amount / 100000;
  if (lakhAmount == 0) {
    // For amounts < 0.01L (₹1,000), show 5 decimal places
    return `₹${lakhAmount.toFixed(2)}L`;
  } else
  if (lakhAmount < 0.01) {
    // For amounts < 0.01L (₹1,000), show 5 decimal places
    return `₹${lakhAmount.toFixed(5)}L`;
  } else if (lakhAmount < 0.1) {
    // For amounts < 0.1L (₹10,000), show 4 decimal places
    return `₹${lakhAmount.toFixed(2)}L`;
  } else if (lakhAmount < 1) {
    // For amounts < 1L (₹1,00,000), show 3 decimal places
    return `₹${lakhAmount.toFixed(2)}L`;
  } else {
    // For amounts >= 1L, show 2 decimal places
    return `₹${lakhAmount.toFixed(2)}L`;
  }
};

/**
 * Format amount with K and L suffixes (legacy format)
 * @param {number} amount - The amount to format
 * @returns {string} Formatted amount string
 */
export const formatAmountLegacy = (amount) => {
  return amount !== null && amount !== undefined ? `₹${amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : "N/A";
  // if (amount >= 100000) {
  //   return `₹${(amount / 100000).toFixed(2)}L`;
  // } else if (amount >= 1000) {
  //   return `₹${(amount / 1000).toFixed(2)}K`;
  // }
  // return `₹${amount.toFixed(2)}`;
};
